export function documentAddScript(js: String) {
	var imports: Array<string> = []
	var lines: Array<string> = []

	for (var line of js.split('\n')) {
		line = line.trim()
		if (line.length === 0) continue
		if (line.startsWith('//')) {
			var m = line.match(RegExp('// *import: +(http.*|/.*)'))
			if (m) imports.push(m[1])
		} else {
			lines.push(line)
		}
	}

	var i: HTMLScriptElement | null = null
	for (var imp of imports) {
		i = document.createElement('script')
		i.setAttribute('src', imp)
		i.setAttribute('type', 'text/javascript')
		// i.async=true -- по умолчанию
		document.head.appendChild(i)
	}

	function appendScriptBody() {
		var s = document.createElement('script')
		s.text = lines.join('\n')
		document.body.appendChild(s)
	}

	if (i) i.addEventListener('load', appendScriptBody) // выполняем скрипт после загрузки последнего импорта
	else appendScriptBody() // выполняем скрипт сразу
}
